import { FC, lazy, Suspense, useEffect, useState } from 'react'
import { FallbackScreen } from '../../comps/FallBackScreen'
import { useLazyApiData, useStores } from '../../data/store'
import { PAYMENT_MODE_SUBTYPES, TEMPLATE } from '../../utils/constants'

const TOneWallet = lazy(() => import('./TOneWallet'))
const WalletComp = lazy(() => import('./WalletComp'))

const Wallet: FC = () => {
  const {
    getInstruments,
    getInstrumentList,
    theme,
    template,
    getConvenienceApi,
    getWalletConvenienceData,
    isConFeeAvailable,
    offerApplied,
  } = useStores((root) => ({
    getInstruments: root.getInsturmentsApi,
    getInstrumentList: root.getInstrumentsList,
    theme: root?.config?.merchantTheme,
    template: root?.merchant.template,
    getConvenienceApi: root?.getConvenienceApi,
    getWalletConvenienceData: root?.getWalletConvenienceData,
    isConFeeAvailable: root.transaction.isConFeeAvailable,
    offerApplied: root.isOfferApplied,
  }))

  const [initialLoading, setInitialLoading] = useState(true)
  const [lazyInsrtumentsApi, { state: instrumentsState, data: instrumentsData }] = useLazyApiData(getInstruments)
  const [lazyGetConvenienceFee] = useLazyApiData(getConvenienceApi)

  const isOfferApplied = offerApplied(PAYMENT_MODE_SUBTYPES.WALLET)

  useEffect(() => {
    if (getInstrumentList(PAYMENT_MODE_SUBTYPES.WALLET).length === 0) {
      lazyInsrtumentsApi(PAYMENT_MODE_SUBTYPES.WALLET)
    }
  }, [getInstrumentList, lazyInsrtumentsApi])

  useEffect(() => {
    if (!isConFeeAvailable(PAYMENT_MODE_SUBTYPES.WALLET, isOfferApplied)) {
      lazyGetConvenienceFee(getWalletConvenienceData(), PAYMENT_MODE_SUBTYPES.WALLET, isOfferApplied)
    }
  }, [getWalletConvenienceData, isConFeeAvailable, isOfferApplied, lazyGetConvenienceFee])

  useEffect(() => {
    setTimeout(() => {
      setInitialLoading(false)
    }, 500)
  }, [])

  const NBCompObj: any = {
    [TEMPLATE.MILK_BASKET]: TOneWallet,
    default: WalletComp,
  }

  const CompName = NBCompObj[template?.id] ?? NBCompObj.default

  return (
    <Suspense fallback={<FallbackScreen />}>
      <CompName
        theme={theme}
        instrumentsState={instrumentsState}
        fetchInstrumentApi={lazyInsrtumentsApi}
        initialLoading={initialLoading}
        message={instrumentsData?.message}
      />
    </Suspense>
  )
}

export default Wallet
